import React from 'react'
import stripeConnectButtonImg from 'img/stripe-connect-button.png'
import useStripeConnect from 'hooks/useStripeConnect'
import PropTypes from 'prop-types'

const StripeConnect = ({ payoutJar }) => {
  const initiateOAuth = useStripeConnect(payoutJar)

  return (
    <input type='image' onClick={initiateOAuth} alt='stripe connect' src={stripeConnectButtonImg} />
  )
}

StripeConnect.propTypes = {
  payoutJar: PropTypes.string.isRequired
}

export default StripeConnect
